import { View, ViewProps } from '@amzn/stencil-react-components/layout';
import React from 'react'
import { useTranslation } from "react-i18next";
import TranslationKeys from 'src/constants/translation-keys';
import { showDeconsolidatedLogin } from "src/constants/feature-gates";

type LogoProps = {
    src: string;
} & ViewProps;

const Logo = (props: LogoProps) => {
    const { t } = useTranslation();
    return (
        <View className={`logo ${props.className}`} style={showDeconsolidatedLogin() ? {paddingBottom: '40px'} : undefined}>
            <img data-testid='atoz-logo' src={props.src} alt={t(TranslationKeys.UI.IMAGE.ATOZ_LOGO_ALT)} />
        </View>
    );
}

export default Logo;